<template>
  <div class="app-base">
    <sidebar />
    <div class="app-base__body">
      <router-view />
    </div>
    <edit-profile-modal />
  </div>
</template>

<script>
import EditProfileModal from './modals/EditProfileModal';
import Sidebar from './Sidebar';

export default {
  components: {
    EditProfileModal,
    Sidebar
  }
};
</script>

<style lang="scss" scoped>
.app-base {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  height: 100%;
  background-color: $app-base-background;

  &__body {
    flex: 1;
    flex-direction: column;
    position: relative;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
